import React from 'react';
import ShortenerDetailsForm from 'components/ShortenerDetailsForm';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import { Field } from 'redux-form'
import copy from 'assets/copy.svg'
import ClipboardButton from 'react-clipboard.js';
import { ShareButtons } from 'react-share';
import FontAwesome from 'react-fontawesome';
import { toastr } from 'react-redux-toastr'

const {
    FacebookShareButton,
    GooglePlusShareButton,
    TwitterShareButton,
} = ShareButtons;

const ShortenerForm = ({ ui, shortener, user, handleSubmit, toggleForm, closeModal, authUser }) => {

  // console.log(state);
  let component = ui.form_visible ? <ShortenerDetailsForm user={user} auth={authUser}/> : '';

  const renderShortenField = ({ input, label, type, meta: { touched, error, warning } }) => (
      <div className={(touched && error) ? 'error' : ''}>
        <input className="shortener__input"  {...input} placeholder={label} type={type}/>
        <button type="submit" className="shortener__button">{shortener.isSending ? 'shortening…' : 'shorten'}</button>
        {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
      </div>
  );

  const DetailsForm = (
      <div>
        <a className={ui.form_visible ? 'shortener__more-button rotated' : 'shortener__more-button'}
           onClick={() => toggleForm()}/>

        <ReactCSSTransitionGroup
            transitionName="slide"
            transitionEnterTimeout={0}
            transitionLeaveTimeout={550}
            transitionAppear={true}
            transitionAppearTimeout={0}
        >
          {component}
        </ReactCSSTransitionGroup>
      </div>
  );

  const ShortenedModal = (
      <div className="modal-overlay">
        <div className="modal">
          <a className="modal__caret" onClick={() => closeModal()}>X</a>

          <div className="modal__top">
            <div className="modal__title">Grab your short link:</div>
            <ClipboardButton component="div" data-clipboard-text={`http://lc.chat/${shortener.response.hash}`}
                             button-className="modal__link" onSuccess={() => toastr.success('Link copied', 'Your link has been copied to your clipboard')}>
              <div className="modal__link__inner">lc.chat/{shortener.response.hash} <img src={copy} alt="Copy"/></div>
            </ClipboardButton>
          </div>
          <div className="modal__content">
            <h5>Share your link</h5>
            <div className="layout__row layout__row--bottom">
              <div className="social-buttons layout__3-5">
                <TwitterShareButton url={`http://lc.chat/${shortener.response.hash}`}><FontAwesome name="twitter"/>
                  Tweet</TwitterShareButton>
                <FacebookShareButton url={`http://lc.chat/${shortener.response.hash}`}><FontAwesome name="facebook"/>
                  Share</FacebookShareButton>
                <GooglePlusShareButton url={`http://lc.chat/${shortener.response.hash}`}><FontAwesome
                    name="google-plus"/> Share</GooglePlusShareButton>
              </div>

              <div className="layout__2-5 modal--right">
                <a className="btn btn--close" onClick={() => closeModal()}>Close</a>
              </div>
            </div>
          </div>
        </div>
      </div>
  );

  return (
      <div>
        <form onSubmit={handleSubmit}
              className="shortener form">
          <div>
            <Field name="url" component={renderShortenField} label="Your long link here" type="text"/>
          </div>

          {DetailsForm}
        </form>

        {shortener.showModal ? ShortenedModal : ''}
      </div>
  );
};

export default ShortenerForm


// WEBPACK FOOTER //
// ./src/components/ShortenerForm.jsx